module.exports = __webpack_public_path__ + "img/scaffolding.467af550.png";